import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { WidthProvider, Responsive } from 'react-grid-layout';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import { GridLayoutModuleWrapper } from '../../../gridLayoutModuleWrapper/GridLayoutModuleWrapper';
import { useContextMenu } from 'react-contexify';
import { AlertsContextMenu } from '../alertsContextMenu/AlertsContextMenu';
// import 'react-grid-layout/css/styles.css';
import './gridLayoutStyle.css';
import 'react-resizable/css/styles.css';
import style from './AlertsGridLayoutContainer.module.css';

const ResponsiveReactGridLayout = WidthProvider(Responsive);
const cols = { xl: 12, lg: 10, md: 8, sm: 6, xs: 4, xxs: 1 };
const breakpoints = {
  xl: 1750,
  lg: 1500,
  md: 1200,
  sm: 900,
  xs: 650,
  xxs: 400,
};

export const AlertsGridLayoutContainer = observer(() => {
  const [currentCols, setCurrentCols] = useState();
  const rowHeight = 100;
  const timeoutRef = useRef(null);
  const { layoutStore } = useWebsocketStore();
  const layouts = layoutStore.currentLayouts.alerts.layouts || {};
  const fullModulelist = layoutStore.currentLayouts.alerts.moduleList;
  const moduleList = layoutStore.alertModuleList;
  const { show } = useContextMenu({ id: 'alertsContextMenu' });

  const displayContextMenu = (e) => {
    e.preventDefault();
    const xPos = e.pageX;
    const yPos = e.pageY;
    show(e, { props: { xPos, yPos } });
  };
  useEffect(() => {
    let breakpoint;
    if (window.innerWidth >= 1500) breakpoint = 'xl';
    if (window.innerWidth >= 1200) breakpoint = 'lg';
    if (window.innerWidth >= 800 && window.innerWidth < 1200) breakpoint = 'md';
    if (window.innerWidth >= 600 && window.innerWidth < 900) breakpoint = 'sm';
    if (window.innerWidth < 650) breakpoint = 'xs';
    if (window.innerWidth < 401) breakpoint = 'xxs';

    setCurrentCols(cols[breakpoint]);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    document.addEventListener('contextmenu', displayContextMenu);
    return () => {
      document.removeEventListener('contextmenu', displayContextMenu);
    };
  }, []);

  return (
    <div className={style.container}>
      <ResponsiveReactGridLayout
        onResizeStop={(_layout, _oldItem, newItem) => {
          layoutStore.updateCurrentLayoutComponentDimensions(
            'alerts',
            newItem.i,
            newItem.w,
            newItem.h
          );
        }}
        draggableCancel=".noDragTag"
        layouts={layouts}
        onLayoutChange={(layout, layouts) => {
          if (layoutStore.receivedCurrentLayouts) {
            layoutStore.setCurrentLayouts('alerts', layouts);
            const timeout = setTimeout(() => {
              layoutStore.updateServerCurrentLayout('alerts', 'currentAlerts');
            }, 20);
            timeoutRef.current = timeout;
          }
        }}
        cols={cols}
        breakpoints={breakpoints}
        rowHeight={rowHeight}
        onBreakpointChange={(breakpoint, cols) => {
          setCurrentCols(cols);
        }}
      >
        {moduleList.map((module) => (
          <GridLayoutModuleWrapper
            data-grid={fullModulelist[module].data}
            key={module}
            moduleId={module}
            layoutType="alerts"
          />
        ))}
      </ResponsiveReactGridLayout>
      <AlertsContextMenu cols={currentCols} rowHeight={rowHeight} />
    </div>
  );
});

/* 
layout structure
alerts: {
  4534534: {
    type: 'watchlist'
    data: {x: 40, y: 50 .....}
    details: {
      watchlistName: 'bestWatchlist'
    }
  }
  4534534: {
    type: 'chart'
    data: {x: 40, y: 50 .....}
    details: {
      symboName: 'AMD',
      numberOfCandles: 40,
      timeUnit: 'MINUTES',
      candleDuration: 5,
    }
  }

}

layout store structure

currentLayouts: {
  alerts: {
    moduleList: [],
    layouts: {},
  }
}


*/
